module.exports = __webpack_public_path__ + "static/img/1-1.ee0b4e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/1-1.png
// module id = q9nL
// module chunks = 0